module.exports = __webpack_public_path__ + "static/img/1692694621238.546e6b42.jpg";